import { z } from "zod";
import { timestampSchema } from "../common.js";
import { formSchemaV1 } from "../form/index.js";
/**
 * A funnel placed on a page as a classic form (16 October 2026). The questions are the funnel's;
 * these are only the words around them. Booking is not part of a page form: it has its own page.
 */
export const pageFormSettingsSchema = z.object({
    submitLabel: z.string().max(40).optional(),
    thankYou: z.string().max(400).optional(),
    /** Offer "Continue on WhatsApp" after sending, with everything the person wrote. */
    showWhatsApp: z.boolean().default(true),
});
export const formDocSchema = z.object({
    name: z.string().min(1).max(80),
    /**
     * What it is for (owner decision, 16 October 2026): a WhatsApp funnel (the chat behind the
     * button) or a contact form placed on a page. Older documents have no kind; see `funnelKind`.
     */
    kind: z.enum(["chat", "page"]).optional(),
    urlPatterns: z.array(z.string().max(200)).max(50).default([]),
    isDefault: z.boolean().default(false),
    /** Draft is free-form while editing; it is validated by the publish callable. */
    draft: z.unknown().optional(),
    publishedVersionId: z.string().optional(),
    whatsappNumber: z.string().optional(),
    /** Shown as a form on a page (owner decision, 16 October 2026): wording after sending. */
    pageForm: pageFormSettingsSchema.optional(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
});
/** A form's kind; contact forms made before the field existed have page form settings and are not the default. */
export function funnelKind(f) {
    return f.kind ?? (f.pageForm && !f.isDefault ? "page" : "chat");
}
export const formVersionSchema = z.object({
    schema: formSchemaV1,
    publishedAt: timestampSchema,
    publishedBy: z.string(),
    note: z.string().max(200).optional(),
});
//# sourceMappingURL=form.js.map